import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    // Check if this is a SNAP detail page
    const snapMatch = location.pathname.match(/^\/snap\/([a-f0-9-]+)$/i);
    if (snapMatch && snapMatch[1]) {
      // Store the SNAP ID for redirect after login
      localStorage.setItem('redirectSnapId', snapMatch[1]);
    }
    
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}